module.exports = __webpack_public_path__ + "static/media/top_background.933e893e.jpg";